import React from "react";
import TimelineItem from "./TimelineItem";

import { useResources } from "@aetonix/hooks";

export default function UrgencyCancelled(props) {
	const {
		localize,
	} = useResources();

	var notification = props.notification;
	var urgencycallcancelled = localize("banner.urgency_cancelled", notification.from);
	var screen = props.screen;

	return (
		<TimelineItem content={urgencycallcancelled} iconName="info"  notification={notification} screen={screen} />
	);
}
